import { connect } from 'react-redux';
import { shareDeviationToPost } from '../../../redux/deviations/actionCreators';
const mapDispatchToProps = (dispatch, { deviation })=>({
        shareToPost: ()=>dispatch(shareDeviationToPost(deviation))
    });
export default connect(null, mapDispatchToProps);
